<template>
  <div class="print">

    <section class="section-approval">
      <div>
        <p class="print-title mb-10">{{ $t("컨베이어 점검표") }}</p>
        <div class="division-title">{{ $t("□ 기본정보") }}</div>
      </div>

      <!-- 결 재 -->
      <table class="table-approval-field mt-auto">
        <colgroup>
          <col width="38" />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0" style="border-bottom: 0">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">{{ $i18n.locale === "ko" ? $t("결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재") : $t("결재") }}</p>
            </div>
          </th>
          <th class="gray">{{ $t("작성자") }}</th>
          <th class="gray">{{ $t("검토자") }}</th>
          <th class="gray">{{ $t("회람자") }}</th>
          <th class="gray">{{ $t("승인자") }}</th>
        </tr>
        <tr>
          <td style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
            </div>
          </td>
          <td style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
            </div>
          </td>
          <td style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
            </div>
          </td>
          <td style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section-stdInfo mb-10">
      <table class="w-full">
        <colgroup></colgroup>
        <tr>
          <th>{{ $t("회사명") }}</th>
          <td>
            <div class="print-input">{{ form.stdInfo.field_name }}</div>
          </td>
          <th>{{ $t("작성자 소속") }}</th>
          <td>
            <div class="print-input">{{ form.stdInfo.section }}</div>
          </td>
        </tr>
        <tr>
          <th>{{ $t("점검일") }}</th>
          <td>
            <div class="print-input">{{ form.inputA_1 }}</div>
          </td>
          <th>{{ $t("작성자 성명") }}</th>
          <td>
            <div class="print-input">{{ form.stdInfo.writer_name }}</div>
          </td>
        </tr>
        <tr>
          <th>{{ $t("검사순서") }}</th>
          <td colspan="3">
            <div class="grid p-4" style="grid-template-columns: 1fr 1fr 1fr 1fr; gap: 1rem">
              <div v-for="(inspect, index) in form.inspectList" :key="`검사순서_${index}`" class="flex text-left">
                <PrintCheckbox :label="`${index > 0 ? index + '. ' : ''}${$t(inspect.title)}`" :value="form.inspectChecked.includes(form.inspectList[index].title)" />
              </div>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section-inspect mb-10 page-break" v-for="inspect in inspectList" v-if="form.inspectChecked.includes(inspect.title)">
      <div class="division-title">□ {{ $t(inspect.title) }}</div>

      <table class="w-full">
        <colgroup>
          <col />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="180" />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t(inspect.tableHeaderTitle) }}</th>
            <th>{{ $t("양호") }}</th>
            <th>{{ $t("미흡") }}</th>
            <th>{{ $t("해당") }}<br />{{ $t("없음") }}</th>
            <th>{{ $t("비고") }}</th>
          </tr>
        </thead>
        <template v-for="(item, i) in inspect.list">
          <tr v-if="item.title">
            <th colspan="5" class="text-left" style="padding: 1rem;">{{ $t(item.title) }}</th>
          </tr>
          <tr :key="`inspect_${i}`">
            <td class="whitespace-pre-line">{{ $t(item.content) }}</td>
            <td>
              <PrintCheckbox :value="item.isChecked === '양호'" class="flex justify-center" />
            </td>
            <td>
              <PrintCheckbox :value="item.isChecked === '미흡'" class="flex justify-center" />
            </td>
            <td>
              <PrintCheckbox :value="item.isChecked === '해당없음'" class="flex justify-center" />
            </td>
            <td>
              {{ item["비고"] }}
            </td>
          </tr>
        </template>
      </table>
    </section>

    <section class="section-photo">
      <div class="division-title">{{ $t("□ 사진대지") }}</div>

      <table class="w-full">
        <colgroup>
          <col width="100" />
          <col />
        </colgroup>
        <template v-for="photo in form.photoList">
          <tr>
            <td colspan="2" style="height: 650px"><img :src="photo.path" width="100%" height="100%" class="max-w-full w-auto object-contain" /></td>
          </tr>
          <tr>
            <td>{{ $t("내용") }}</td>
            <td class="text-left">{{ photo.input }}</td>
          </tr>
        </template>
      </table>
    </section>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: { PrintCheckbox },

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },

  computed: {
    inspectList() {
      let tempTitle = "";
      for (const inspect of this.form.inspectList) {
        for (const item of inspect.list) {
          if (tempTitle !== item.title) {
            tempTitle = item.title;
          } else {
            item.title = "";
          }
        }
      }
      return this.form.inspectList;
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3c3c3c;
    padding: 1.25rem 0rem;
  }

  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 80px;
      object-fit: contain;
      display: block;
    }
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      word-break: break-word;
      white-space: normal;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      padding: 1.5rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .check-container {
      padding: 10px 14px 0 14px;
      text-align: left;

      div {
        margin-bottom: 8px;
      }
      img {
        display: inline-block;
        margin-right: 8px;
      }
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 결재란 */
  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;

    .table-approval-field {
      th {
        width: 120px;
        padding: 10px 14px;
      }
      th:first-child {
        width: 38px;
      }
      td {
        height: 80px;
      }

      tr:last-child {
        th,
        td {
          border-bottom: none;
        }
      }
    }
  }

  /* 기본정보 */
  .section-stdInfo {
    th {
      width: 140px;
    }
    td div {
      border: none;
    }
  }

  /* 점검대상 */
  .section-inspect {
    td {
      padding: 1rem;
      text-align: left;
    }
  }

  .section-file {
    th {
      width: 234px;
    }
  }

  .section-photo {
    td {
      padding: 1rem;
    }
  }
}

@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  thead {
    display: table-header-group;
  }
}
</style>
